import type { RequestEvent } from '@sveltejs/kit';

import { sentry } from '$shared/helpers/logger/sentry';
import { OtherExpection } from '$shared/exceptions/OtherExpection';

type HookInput = {
  event: RequestEvent;
  resolve(event: RequestEvent, opts?: any): Promise<Response>;
};

type ErrorInput = { error: Error & { frame?: string }; event: RequestEvent };

/** @type {import('@sveltejs/kit').Handle} */
export async function handle({ event, resolve }: HookInput): Promise<Response> {
  const response: Response = await resolve(event, {
    ssr: false
  });

  return response;
}

/** @type {import('@sveltejs/kit').HandleError} */
export async function handleError({ error, event }: ErrorInput): Promise<void> {
  const exception = OtherExpection.from('Hooks Server', 'handleError', error, {
    event
  });
  sentry.log(exception);
}
